module.exports = __webpack_public_path__ + "static/media/beijing.da5a80e2.png";